import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-ico",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-ico.component.html",
  styleUrl: "./prefix-ico.component.less",
})
export class PrefixIcoComponent extends PrefixTextComponent {
  public constructor() {
    super();
    this.post = false;
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["ico"];
  }
}
